import React from 'react';
import { IconButton, Theme } from '@mui/material';
import { ChevronLeft } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';

interface BackButtonProps {
  classes?: ReturnType<typeof useStyles>;
  onClick?: Function;
  fontSize?: number;
  className?: any;
}

export const BackButton: React.FC<BackButtonProps> = props => {
  const navigate = useNavigate();
  const { onClick } = props;
  const { classes } = useStyles();

  const handleClick = e => {
    if (onClick) {
      onClick(e);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className={props.className}>
      <IconButton onClick={e => handleClick(e)} size="medium" className={ props.className || classes.icon }>
        <ChevronLeft sx={{ color: 'white' }} fontSize="large" />
      </IconButton>
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) =>
  ({
    icon: {
      color: theme.colors.peacockBlue,
      opacity: 0.75,
    },
  })
);
